export const QUICK_LINK = [
  {
    id: "1",
    title: "Join MyRAKtherm",
    link: "/raktherm-worldwide/join-my-raktherm",
  },
  {
    id: "2",
    title: "Get Local Support",
    link: "/services-and-support/guidelines",
  },
  {
    id: "3",
    title: "Ultimate Solutions",
    link: "/solutions/ultimate-solutions",
  },
  {
    id: "4",
    title: "Download Brochures",
    link: "/services-and-support/catalogues-and-downloads",
  },
  {
    id: "5",
    title: "Join RAKtherm Academy",
    link: "/raktherm-academy",
  },
  {
    id: "6",
    title: "Join RAKtherm Plumber Community",
    link: "/plumber-community",
  },
];

export const PRODUCT_RANGE = [
  {
    id: "1",
    title: "PPR Piping Systems",
    link: "/piping-technologies",
    ref: "",
    sublink: [],
  },
  {
    id: "2",
    title: "MULTI-LAYER Reinforced PVC-U Piping Systems",
    link: "/piping-technologies",
    ref: "",
    sublink: [
      {
        sublink_title: "Solvent Joint System",
        sublink_link: "/piping-technologies",
      },
      {
        sublink_title: "Push-Fit Joint System",
        sublink_link: "/piping-technologies",
      },
    ],
  },
  {
    id: "3",
    title: "PEX Piping Systems",
    link: "/piping-technologies",
    ref: "",
    sublink: [],
  },
  {
    id: "4",
    title: "Anti-UV Piping Systems",
    link: "/piping-technologies",
    ref: "",
    sublink: [],
  },
  {
    id: "5",
    title: "Reinforced Piping Systems",
    link: "/piping-technologies",
    ref: "",
    sublink: [],
  },
];

export const ABOUT_US = [
  {
    id: "1",
    title: "A Glance",
    link: "a-glance",
  },
  {
    id: "2",
    title: "Corporate Strategy",
    link: "corporate-strategy",
  },
  {
    id: "3",
    title: "Chairman's Message",
    link: "chairmans-message",
  },
  {
    id: "4",
    title: "Sustained Development",
    link: "sustained-development",
  },
];

export const SOLUTIONS = [
  {
    id: "1",
    title: "Piping Technologies",
    link: "piping-technologies",
  },
  {
    id: "2",
    title: "Piping Systems Usage",
    link: "piping-systems-usage",
  },
  {
    id: "3",
    title: "Ultimate Solutions",
    link: "ultimate-solutions",
  },
  {
    id: "4",
    title: "RAKtherm Quality",
    link: "raktherm-quality",
  },
];

export const SERVICES_AND_SUPPORT = [
  {
    id: "1",
    title: "Catalogues & Downloads",
    link: "catalogues-and-downloads",
  },
  {
    id: "2",
    title: "Certifications",
    link: "certifications",
  },
  {
    id: "3",
    title: "Guidelines",
    link: "guidelines",
  },
];

export const RAKTHERM_WORLDWIDE = [
  {
    id: "1",
    title: "Global Networks",
    link: "global-networks",
  },
  {
    id: "2",
    title: "Mega Projects",
    link: "mega-projects",
  },
  {
    id: "3",
    title: "Become Stockist",
    link: "become-stockist",
  },
  {
    id: "4",
    title: "Join My RAKtherm",
    link: "join-my-raktherm",
  },
];

export const RAKTHERM_WORLDWIDE_CONTACT = [
  {
    id: "1",
    title: "Global Networks",
    link: "global-networks",
  },
  {
    id: "2",
    title: "Mega Projects",
    link: "mega-projects",
  },
  {
    id: "3",
    title: "Become Stockist",
    link: "become-stockist",
  },
];

export const DASHBOARD_LINKS = [
  {
    id: "1",
    title: "Dashboard",
    link: "/dashboard/home",
  },
  {
    id: "2",
    title: "My RAKtherm",
    link: "/raktherm-worldwide/join-my-raktherm",
  },
  {
    id: "3",
    title: "My Success Stories",
    link: "/dashboard/success-stories",
  },
  {
    id: "4",
    title: "My Special Moments",
    link: "/dashboard/special-moments",
  },
  {
    id: "5",
    title: "My Trainings",
    link: "/dashboard/trainings",
  },
  {
    id: "6",
    title: "Plumber Community",
    link: "/plumber-community/menu",
  },
  {
    id: "7",
    title: "Catalogues & Downloads",
    link: "/services-and-support/catalogues-and-downloads",
  },
  {
    id: "8",
    title: "Update Profile",
    link: "/dashboard/update-profile",
  },
];
